import style from "./Footer.module.css"

function Footer() {
    return (
        <footer className={style.footer}>
                    <small>
                        © {new Date().getFullYear()} ReproBird.
                        Todos os direitos reservados.
                    </small>
        </footer>
    )
}

export default Footer;
